<template>
  <a-dialog ref="dialog" name="add_urls" :loading="loading" size="large" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <v-form v-model="form.valid" class="mt-4" ref="form">
        <v-textarea
          filled
          v-model="form.fields.urls"
          :rules="form.rules.urls"
          :label="$t('label')"
          :hint="$t('hint', { count: remainingUrlsCount} )"
        ></v-textarea>
      </v-form>
    </div>
    <span slot="actions">
      <v-btn
        color="primary"
        text
        :disabled="!form.valid"
        @click="submit">
        {{ $t('actions.add') }} {{ urlsList.length }} {{ $t('url') }}
        </v-btn>
    </span>
  </a-dialog>
</template>

<script>
import Normalize from 'check-position-normalize'

export default {
  name: 'AddUrlsDialog',
  data () {
    return {
      loading: '',
      form: {
        valid: false,
        fields: {
          urls: '',
        },
        rules: {
          urls: [
            v => !!v || this.$t('required'),
            () => {
              if (this.remainingUrlsCount === null || this.remainingUrlsCount >= 0) {
                return true
              } else {
                return this.$t('max', { count: this.$account.current.rules['check-position'].max_url_monitor })
              }
            }
          ],
        }
      },
    }
  },
  computed: {
    remainingUrlsCount () {
      return this.$account.current.rules['check-position'].max_url_monitor - (this.$services.urlMonitoring.urlMonitors.all.length + this.urlsList.length)
    },
    urlsList () {
      return Normalize.url(
        Array.from(new Set(this.form.fields.urls.split('\n'))),
        {
          add_default_protocol: 'https://'
        }
      ).filter(term => term !== '')
    }
  },
  methods: {
    async submit () {
      this.loading = this.$t('add')
      if (this.$refs.form.validate()) {
        try {
          await this.$api.post('url-monitors', {
            urls: this.urlsList
          })

          this.$ui.success(this.$t('success'))
          this.$bus.emit('url-monitoring/require_refresh')
          if (this.$refs.dialog) this.$refs.dialog.close()
        } catch (err) {
          if (err.exception === 'ThrottledCreateUrlMonitorException') {
            this.$ui.error(this.$t('error'))
          }
        } finally {
          this.loading = ''
        }
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"add": "Adding URLs ...",
		"error": "Unable to add more than 200 URLs during tool trial phase.",
		"hint": "You can add another {count} URL to your account.",
		"label": "URL (one per line)",
		"max": "Too many URLs inserted (maximum of the account: {count}).",
		"required": "At least one URL is required",
		"success": "URLs have been added, analysis may take a few minutes.",
		"title": "Add urls",
		"url": "URL"
	},
	"es": {
		"add": "Añadiendo URL ...",
		"error": "No se pueden agregar más de 200 URL durante la fase de prueba de la herramienta.",
		"hint": "Puede agregar {count} URL a su cuenta.",
		"label": "URL (una por línea)",
		"max": "Demasiadas URL insertadas (máximo de la cuenta: {count}).",
		"required": "Se requiere al menos una URL",
		"success": "Se han agregado URL, el análisis puede tardar unos minutos.",
		"title": "Añadir URL",
		"url": "URL"
	},
	"fr": {
		"add": "Ajout des URL ...",
		"error": "Impossible d'ajouter plus de 200 URL pendant la phase d'essai de l'outil.",
		"hint": "Vous pouvez ajouter encore {count} URL sur votre compte.",
		"label": "URL (une par ligne)",
		"max": "Trop d'URL insérées (maximum du compte : {count}).",
		"required": "Au moins une URL est requise",
		"success": "Les URL ont été ajoutés, l'analyse peut prendre quelques minutes.",
		"title": "Ajouter des URL",
		"url": "URL"
	},
	"it": {
		"add": "Aggiunta URL ...",
		"error": "Impossibile aggiungere più di 200 URL durante la fase di prova dello strumento.",
		"hint": "Puoi aggiungere altri {count} URL al tuo account.",
		"label": "URL (uno per riga)",
		"max": "Troppi URL inseriti (massimo dell'account: {count}).",
		"required": "È richiesto almeno un URL",
		"success": "Gli URL sono stati aggiunti, l'analisi potrebbe richiedere qualche minuto.",
		"title": "Aggiungi URL",
		"url": "URL"
	},
	"pt": {
		"add": "A adicionar URLs ...",
		"error": "Impossível adicionar mais de 200 URLs durante a fase de experimentação da ferramenta.",
		"hint": "Pode adicionar mais {count} URL à sua conta.",
		"label": "URL (um por linha)",
		"max": "Demasiados URLs inseridos (máximo da conta: {count}).",
		"required": "É necessário pelo menos um URL",
		"success": "Os URLs foram adicionados, a análise pode demorar alguns minutos.",
		"title": "Adicionar URLs",
		"url": "URL"
	},
	"pl": {
		"add": "Dodawanie URL-i ...",
		"error": "Nie można dodać więcej niż 200 URL-i podczas fazy próbnej narzędzia.",
		"hint": "Możesz dodać jeszcze {count} URL do swojego konta.",
		"label": "URL (jeden na linię)",
		"max": "Zbyt wiele URL-i (maksimum dla konta: {count}).",
		"required": "Wymagany jest co najmniej jeden URL",
		"success": "URL-e zostały dodane, analiza może potrwać kilka minut.",
		"title": "Dodaj URL-e",
		"url": "URL"
	}
}
</i18n>

